import { resizeProperty } from '@/helpers';
import { Alert } from '@mantine/core';
import { IconBulbFilled } from '@tabler/icons-react';
import { TextFragment } from './TextFragment';

export function Callout({ item, formValues = {}, containerWidth }) {
  return (
    <Alert
      p={resizeProperty(containerWidth, 16)}
      variant="default"
      mb="md"
      icon={<IconBulbFilled size={60} color="#faca2b" stroke={1.5} />}
      styles={{
        message: {
          color: formValues.body_font_color,
          fontFamily: formValues.body_font_family,
          fontWeight: formValues.body_font_weight,
          fontSize: resizeProperty(containerWidth, formValues.body_font_size),
          textAlignment: formValues.body_alignment,
          fontStyle: formValues.body_italic ? 'italic' : 'normal',
          textDecoration:
            `${formValues.body_underlined ? 'underline ' : ''}${formValues.body_strikethrough ? 'line-through' : ''}`.trim(),
        },
        icon: {
          width: resizeProperty(containerWidth, 60),
          height: resizeProperty(containerWidth, 60),
        },
      }}
    >
      {item.richText.map((d, index) => (
        <TextFragment
          fragment={d}
          key={index}
          formValues={formValues}
          containerWidth={containerWidth}
        />
      ))}
    </Alert>
  );
}
